import type { ConfigurationContextValue } from "@/components/atomic-crm/root/ConfigurationContext";
// Import the logos as module assets so Vite resolves their URL relative to the
// JS chunk (import.meta.url), not the current route. A plain "./logos/..." path
// breaks on nested routes like /oauth/consent and under a deployment sub-path.
import narsLogo from "@/nars/logo.svg";

export const narsDarkModeLogo = narsLogo;
export const narsLightModeLogo = narsLogo;

export const narsCurrency = "EUR";

export const narsTitle = "NARS CRM";

export const narsCompanySectors = [
  { value: "communication-services", label: "Communication Services" },
  { value: "consumer-discretionary", label: "Consumer Discretionary" },
  { value: "consumer-staples", label: "Consumer Staples" },
  { value: "energy", label: "Energy" },
  { value: "financials", label: "Financials" },
  { value: "health-care", label: "Health Care" },
  { value: "industrials", label: "Industrials" },
  { value: "information-technology", label: "Information Technology" },
  { value: "materials", label: "Materials" },
  { value: "real-estate", label: "Real Estate" },
  { value: "utilities", label: "Utilities" },
];

export const narsDealStages = [
  { value: "opportunity", label: "Da valutare" },
  { value: "proposal-sent", label: "Proposta inviata" },
  { value: "in-negociation", label: "In trattativa" },
  { value: "won", label: "Acquisita" },
  { value: "lost", label: "Persa" },
  { value: "delayed", label: "In pausa" },
];

export const narsDealPipelineStatuses = ["won"];

export const narsDealCategories = [
  { value: "photo-product-ai", label: "Foto prodotto AI" },
  { value: "video-product-ai", label: "Video prodotto AI" },
  { value: "meta-ads", label: "Meta Ads" },
  { value: "on-location", label: "Foto e video dal vivo" },
  { value: "social-management", label: "Gestione social" },
  { value: "website-design", label: "Sito web" },
  { value: "other", label: "Altro" },
];

export const narsNoteStatuses = [
  { value: "cold", label: "Freddo", color: "#7dbde8" },
  { value: "warm", label: "Tiepido", color: "#e8cb7d" },
  { value: "hot", label: "Caldo", color: "#e88b7d" },
  { value: "in-contract", label: "Cliente", color: "#a4e87d" },
];

export const narsTaskTypes = [
  { value: "none", label: "Attività" },
  { value: "email", label: "Email" },
  { value: "demo", label: "Presentazione" },
  { value: "lunch", label: "Incontro" },
  { value: "meeting", label: "Riunione" },
  { value: "follow-up", label: "Ricontatto" },
  { value: "thank-you", label: "Ringraziamento" },
  { value: "ship", label: "Consegna" },
  { value: "call", label: "Chiamata" },
];

export const narsConfiguration: ConfigurationContextValue = {
  companySectors: narsCompanySectors,
  currency: narsCurrency,
  dealCategories: narsDealCategories,
  dealPipelineStatuses: narsDealPipelineStatuses,
  dealStages: narsDealStages,
  noteStatuses: narsNoteStatuses,
  taskTypes: narsTaskTypes,
  title: narsTitle,
  darkModeLogo: narsDarkModeLogo,
  lightModeLogo: narsLightModeLogo,
};
